import { render, staticRenderFns } from "./DashboardNavbarTrainings.vue?vue&type=template&id=6567647f"
import script from "./DashboardNavbarTrainings.vue?vue&type=script&lang=js"
export * from "./DashboardNavbarTrainings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports